<template>
  <div :class="[{ 'one-px-border': containerBorder }, 'star-rating-widget']">
    <div v-if="starDescriptionText" class="columns is-mobile is-marginless is-hidden-tablet">
      <div class="column hero">
        <div class="hero-body with-stars">
          <div class="container is-fluid">
            <p class="is-size-2 has-text-weight-bold has-text-centered" v-text="finalScore"></p>
            <p class="has-text-centered is-size-6 star-row"><rating :enlarge-mobile="enlargeMobile" :stars="getStarAverageWholeNumber" :shrink="starDescriptionText" ></rating></p>
            <p class="is-size-6 has-text-centered">AVG RATING</p>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-mobile is-marginless">
      <div v-if="!starDescriptionText" class="column is-4 hero">
        <div class="hero-body">
          <div class="container is-fluid">
            <p class="is-size-7 has-text-weight-bold has-text-centered">AVERAGE STAR</p>
            <p class="is-size-7 has-text-centered">RATING OUT OF 5</p>
            <p class="is-size-1 has-text-weight-bold has-text-centered" v-text="finalScore || 3"></p>
            <p class="is-size-7 has-text-centered">FROM <span class="has-text-weight-bold" >{{ totalReviews || 275 }}</span></p>
            <p class="is-size-7 has-text-centered">REVIEWS</p>
          </div>
        </div>
      </div>
      <div v-if="starDescriptionText" class="column is-hidden-mobile is-4 hero">
        <div class="hero-body with-stars">
          <div class="container is-fluid">
            <p class="is-size-2 has-text-weight-bold has-text-centered" v-text="finalScore"></p>
            <p class="has-text-centered is-size-7"><rating :stars="getStarAverageWholeNumber" :shrink="starDescriptionText" ></rating></p>
            <p class="is-size-6 has-text-centered">AVG RATING</p>
          </div>
        </div>
      </div>
      <div class="column">
        <!-- FIVE STARS -->
        <div class="columns is-mobile is-gapless level">
          <div v-if="!starDescriptionText" class="column is-3-mobile is-3-tablet level-item">
            <p class="is-size-7">
              <span class="icon">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </span>
            </p>
          </div>
          <div v-if="starDescriptionText" class="column is-3-mobile is-1-tablet level-item">
            <p class="is-size-6">5 Star</p>
          </div>
          <div :class="['column is-6-mobile', { 'is-7-tablet' : !starDescriptionText }, { 'is-5-tablet' : starDescriptionText },'level-item']">
            <p class="is-size-7"><progress :class="['progress is-five', { 'is-small': smallBars }]" :value="percentageFiveStars" max="100">{{ percentageFiveStars }}&#37;</progress></p>
          </div>
          <div :class="[{ 'column is-2 level-item': !starDescriptionText}, { 'column is-3 level-item' : starDescriptionText }]">
            <p :class="['is-size-7', { 'bigger-percentage': !smallBars }]">&nbsp;&nbsp;{{ five }}&nbsp;({{ percentageFiveStars }}&#37;)</p>
          </div>
        </div>
        <!-- FOUR STARS -->
        <div class="columns is-mobile is-gapless level">
          <div v-if="!starDescriptionText" class="column is-3-mobile is-3-tablet level-item">
            <p class="is-size-7">
              <span class="icon">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </span>
            </p>
          </div>
          <div v-if="starDescriptionText" class="column is-3-mobile is-1-tablet level-item">
            <p class="is-size-6">4 Star</p>
          </div>
          <div :class="['column is-6-mobile', { 'is-7-tablet' : !starDescriptionText }, { 'is-5-tablet' : starDescriptionText },'level-item']">
            <p class="is-size-7"><progress :class="['progress is-four', { 'is-small': smallBars }]" :value="percentageFourStars" max="100">{{ percentageFourStars }}&#37;</progress></p>
          </div>
          <div :class="[{ 'column is-2 level-item': !starDescriptionText}, { 'column is-3 level-item' : starDescriptionText }]">
            <p :class="['is-size-7', { 'bigger-percentage': !smallBars }]">&nbsp;&nbsp;{{ four }}&nbsp;({{ percentageFourStars }}&#37;)</p>
          </div>
        </div>
        <!-- THREE STARS -->
        <div class="columns is-mobile is-gapless level">
          <div v-if="!starDescriptionText" class="column is-3-mobile is-3-tablet level-item">
            <p class="is-size-7">
              <span class="icon">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </span>
            </p>
          </div>
          <div v-if="starDescriptionText" class="column is-3-mobile is-1-tablet level-item">
            <p class="is-size-6">3 Star</p>
          </div>
          <div :class="['column is-6-mobile', { 'is-7-tablet' : !starDescriptionText }, { 'is-5-tablet' : starDescriptionText },'level-item']">
            <p class="is-size-7"><progress :class="['progress is-three', { 'is-small': smallBars }]" :value="percentageThreeStars" max="100">{{ percentageThreeStars }}&#37;</progress></p>
          </div>
          <div :class="[{ 'column is-2 level-item': !starDescriptionText}, { 'column is-3 level-item' : starDescriptionText }]">
            <p :class="['is-size-7', { 'bigger-percentage': !smallBars }]">&nbsp;&nbsp;{{ three }}&nbsp;({{ percentageThreeStars }}&#37;)</p>
          </div>
        </div>
        <!-- TWO STARS -->
        <div class="columns is-mobile is-gapless level">
          <div v-if="!starDescriptionText" class="column is-3-mobile is-3-tablet level-item">
            <p class="is-size-7">
              <span class="icon">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </span>
            </p>
          </div>
          <div v-if="starDescriptionText" class="column is-3-mobile is-1-tablet level-item">
            <p class="is-size-6">2 Star</p>
          </div>
          <div :class="['column is-6-mobile', { 'is-7-tablet' : !starDescriptionText }, { 'is-5-tablet' : starDescriptionText },'level-item']">
            <p class="is-size-7"><progress :class="['progress is-two', { 'is-small': smallBars }]" :value="percentageTwoStars" max="100">{{ percentageTwoStars }}&#37;</progress></p>
          </div>
          <div :class="[{ 'column is-2 level-item': !starDescriptionText}, { 'column is-3 level-item' : starDescriptionText }]">
            <p :class="['is-size-7', { 'bigger-percentage': !smallBars }]">&nbsp;&nbsp;{{ two }}&nbsp;({{ percentageTwoStars }}&#37;)</p>
          </div>
        </div>
        <!-- ONE STAR -->
        <div class="columns is-mobile is-gapless level">
          <div v-if="!starDescriptionText" class="column is-3-mobile is-3-tablet level-item">
            <p class="is-size-7">
              <span class="icon">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </span>
            </p>
          </div>
          <div v-if="starDescriptionText" class="column is-3-mobile is-1-tablet level-item">
            <p class="is-size-6">1 Star</p>
          </div>
          <div :class="['column is-6-mobile', { 'is-7-tablet' : !starDescriptionText }, { 'is-5-tablet' : starDescriptionText },'level-item']">
            <p class="is-size-7"><progress :class="['progress is-one', { 'is-small': smallBars }]" :value="percentageOneStars" max="100">{{ percentageOneStars }}&#37;</progress></p>
          </div>
          <div :class="[{ 'column is-2 level-item': !starDescriptionText}, { 'column is-3 level-item' : starDescriptionText }]">
            <p :class="['is-size-7', { 'bigger-percentage': !smallBars }]">&nbsp;&nbsp;{{ one }}&nbsp;({{ percentageOneStars }}&#37;)</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!hideLogo" class="columns is-mobile is-paddingless is-marginless">
      <div class="column is-paddingless is-2 is-offset-10">
        <figure class="image">
          <img src="/static/img/logo/hp-logo.svg" alt="Hellopeter.com" />
        </figure>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import Rating from './../components/Rating.vue'

  export default {
    name: 'StarRatingWidget',
    components: {
      Rating
    },
    props: {
      containerBorder: {
        type: Boolean,
        default: false
      },
      /**
       * Average Star Rating
       */
      finalScore: {
        type: Number,
        default: 0
      },
      /**
       * Total Reviews
       */
      totalReviews: {
        type: Number,
        default: 0
      },
      /**
       * Count of One Star reviews
       */
      one: {
        type: Number,
        default: 0
      },
      /**
       * Count of Two Star reviews
       */
      two: {
        type: Number,
        default: 0
      },
      /**
       * Count of Three Star reviews
       */
      three: {
        type: Number,
        default: 0
      },
      /**
       * Count of Four Star reviews
       */
      four: {
        type: Number,
        default: 0
      },
      /**
       * Count of Five Star reviews
       */
      five: {
        type: Number,
        default: 0
      },
      /**
       * Hide Hellopeter logo
       */
      hideLogo: {
        type: Boolean,
        default: false
      },
      smallBars: {
        type: Boolean,
        default: true
      },
      starDescriptionText: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        enlargeMobile: true
      }
    },
    computed: {
      percentageFiveStars () {
        if (this.five > 0) {
          return ((this.five / this.totalReviews) * 100).toFixed(0)
        }
        return 0
      },
      percentageFourStars () {
        if (this.four > 0) {
          return ((this.four / this.totalReviews) * 100).toFixed(0)
        }
        return 0
      },
      percentageThreeStars () {
        if (this.three > 0) {
          return ((this.three / this.totalReviews) * 100).toFixed(0)
        }
      },
      percentageTwoStars () {
        if (this.two > 0) {
          return ((this.two / this.totalReviews) * 100).toFixed(0)
        }
        return 0
      },
      percentageOneStars () {
        if (this.one > 0) {
          return ((this.one / this.totalReviews) * 100).toFixed(0)
        }
        return 0
      },
      getStarAverageWholeNumber () {
        if (this.finalScore > 0) {
          return parseInt(this.finalScore.toFixed(0))
        }
        return 0
      }
    }
  }
</script>
<style scoped>
  .hero-body {
    padding: 0.5rem;
    background-color: #25b888;
  }

  .hero-body.with-stars {
    background-color: transparent;
    color: #58595B;
  }

  .hero-body.with-stars > .container.is-fluid > p:nth-child(3) {
    margin-top: 0.3rem;
  }

  .is-size-1 {
    line-height: 3.5rem;
  }

  .hero {
    color: #ffffff;
  }

  .has-text-weight-bold {
    font-weight: bolder;
  }

  .icon {
    width: auto;
  }

  .progress {
    border-radius: 0;
  }

  .columns.is-gapless.level:not(:last-child) {
    margin-bottom: 0.3rem;
  }

  .columns.is-gapless.level .is-size-7 {
    font-size: 0.5rem!important;
  }

  .columns.is-gapless.level .is-size-7.bigger-percentage {
    font-size: 1rem!important;
  }

  /* FIVE STAR PROGRESS BAR*/
  .progress.is-five::-webkit-progress-value {
    background-color: #25b888;
  }
  .progress.is-five::-moz-progress-bar {
    background-color: #25b888;
  }
  .progress.is-five::-ms-fill {
    background-color: #25b888;
  }

  /* FOUR STAR PROGRESS BAR*/
  .progress.is-four::-webkit-progress-value {
    background-color: #60c3a7;
  }
  .progress.is-four::-moz-progress-bar {
    background-color: #60c3a7;
  }
  .progress.is-four::-ms-fill {
    background-color: #60c3a7;
  }

  /* THREE STAR PROGRESS BAR*/
  .progress.is-three::-webkit-progress-value {
    background-color: #fbbb4e;
  }
  .progress.is-three::-moz-progress-bar {
    background-color: #fbbb4e;
  }
  .progress.is-three::-ms-fill {
    background-color: #fbbb4e;
  }

  /* TWO STAR PROGRESS BAR*/
  .progress.is-two::-webkit-progress-value {
    background-color: #f89b58;
  }
  .progress.is-two::-moz-progress-bar {
    background-color: #f89b58;
  }
  .progress.is-two::-ms-fill {
    background-color: #f89b58;
  }

  /* ONE STAR PROGRESS BAR*/
  .progress.is-one::-webkit-progress-value {
    background-color: #f05645;
  }
  .progress.is-one::-moz-progress-bar {
    background-color: #f05645;
  }
  .progress.is-one::-ms-fill {
    background-color: #f05645;
  }

  .columns.is-gapless.level > .column.is-3-mobile.is-3-tablet.level-item:first-child > .is-size-7 {
    color: #e5e5e5;
  }

  .columns.is-gapless.level:first-child .fas.fa-star {
    color: #25b888;
  }

  .columns.is-gapless.level:nth-child(2) .fas.fa-star:not(:last-child) {
    color: #60c3a7;
  }

  .columns.is-gapless.level:nth-child(3) .fas.fa-star:nth-child(1), .columns.is-gapless.level:nth-child(3) .fas.fa-star:nth-child(2), .columns.is-gapless.level:nth-child(3) .fas.fa-star:nth-child(3) {
    color: #fbbb4e;
  }

  .columns.is-gapless.level:nth-child(4) .fas.fa-star:nth-child(1), .columns.is-gapless.level:nth-child(4) .fas.fa-star:nth-child(2) {
    color: #f89b58;
  }

  .columns.is-gapless.level:nth-child(5) .fas.fa-star:nth-child(1) {
    color: #f05645;
  }

  figure > img {
    border-radius: 0;
    padding-right: 1rem;
  }

  figure.image {
    margin-bottom: 15px;
  }

  .one-px-border {
    border: 1px solid #cccccc;
  }

  .container.is-fluid {
    margin: 0;
  }

  .star-rating-widget {
    max-width: 605px;
  }

  .bigger-percentage {
    font-size: 1rem!important;
  }

  @media screen and (max-width: 767px) {
    .columns.is-gapless.level .is-size-7 {
      font-size: 0.5rem!important;
    }

    .columns.is-mobile.is-marginless .is-size-7 {
      font-size: 0.4rem!important;
    }

    .columns.is-mobile.is-marginless .is-size-1 {
      font-size: 2.4rem!important;
      line-height: 2.4rem;
    }

    .columns.is-gapless.level:not(:last-child) {
      margin-bottom: 0;
    }

    .icon {
      height: 1.1rem;
    }
  }

</style>




// WEBPACK FOOTER //
// src/widgets/StarRatingWidget.vue